import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!

  return (_openBlock(), _createBlock(_component_base_svg_icon, {
    class: _normalizeClass(["w-6 transform transition-transform duration-500 cursor-pointer", _ctx.switchOpenIcon]),
    path: _ctx.mdiChevronDown
  }, null, 8, ["class", "path"]))
}